import { useCallback } from 'react';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import CorporateMarketIssueTile from '@/creditflowresearch/ui/components/deals/DealTiles/CorporateMarketIssueTile/CorporateMarketIssueTile';
import DealStatusContextProvider from '@/creditflowresearch/application/Deal/contexts/DealStatusContext';
import ProductsContextProvider from '@/creditflowresearch/application/Deal/contexts/ProductsContext';
import DealRepository from '@/creditflowresearch/infrastructure/repository/DealRepository';
import { getContainer } from '@framework/di/getContainer';
import { DealTooltipProvider } from '@/creditflowresearch/application/Deal/contexts/DealTooltipContext';
import CorporateMarketPageContext, { ICorporateMarketPageDealsCollection } from '@/creditflowresearch/application/Deal/contexts/IssueTile/CorporateMarketPageContext';
import { IMarketPagePayload } from '@/creditflowresearch/application/Deal/types';
import { TableDictionariesProvider } from '@/creditflowresearch/application/TableDictionaries';
import { useDictionariesContext } from '@/creditflowresearch/application/Dictionaries/v2/DictionariesContext';

export default () => {
  const { deals, availableProductIds } = useParentPageContext();
  const { countries } = useDictionariesContext();
  const container = getContainer();
  const dealRepository = container.get<DealRepository>(DealRepository);
  const fetchDeals = useCallback(
    (payload: IMarketPagePayload) => dealRepository.getCfrCorporateDeals(payload),
    [dealRepository],
  ) as unknown as (payload: IMarketPagePayload) => Promise<ICorporateMarketPageDealsCollection>;
  return (
    <DealStatusContextProvider filters={ deals?.pageFilters?.filters }>
      <ProductsContextProvider availableProductIds={ availableProductIds }>
        <DealTooltipProvider>
          <CorporateMarketPageContext
            deals={ deals as ICorporateMarketPageDealsCollection }
            fetch={ fetchDeals }
          >
            <TableDictionariesProvider dictionaries={ { countries } }>
              <CorporateMarketIssueTile defaultExpandedRowIndexes={ [0] } />
            </TableDictionariesProvider>
          </CorporateMarketPageContext>
        </DealTooltipProvider>
      </ProductsContextProvider>
    </DealStatusContextProvider>
  );
};
